import React, { createContext, useState, useContext, useEffect } from 'react';
import { BeatLoader } from 'react-spinners';
import { BookingHoteDetailAndImagesAPI, GetProfileDetailAPI, GetUserWalletAPI } from '../API/Get';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const userToken = localStorage.getItem('user_Token');
    if (userToken) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
    setLoading(false); 
  }, []); 

  const login = async(token) => {
    localStorage.setItem('user_Token', token);
    setIsAuthenticated(true);
    window.location.reload();
  };
  const logout = () => {
    localStorage.removeItem('user_Token');
    setIsAuthenticated(false);
  };
  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

 
